module.exports = __webpack_public_path__ + "img/shot-4.a3aad5c7.png";